// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasServicos_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /relatorios/vendas_servicos/lista (chamado 2026-0086): os itens
 * de serviço do período e os KPIs por (serviço, prioridade) calculados sobre
 * a mesma lista. `combos` (NS 2026-0090): os combos pré-pagos vendidos no
 * período, por combo, com valor.
 */
import type { VendasServicos_ComboRow } from './VendasServicos_ComboRow'
import type { VendasServicos_ItemRow } from './VendasServicos_ItemRow'
import type { VendasServicos_KpiRow } from './VendasServicos_KpiRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface VendasServicos_ListaResponseDados {
itens: VendasServicos_ItemRow[]
kpis: VendasServicos_KpiRow[]
combos: VendasServicos_ComboRow[]
}

export type VendasServicos_ListaResponse = ApiResponse<VendasServicos_ListaResponseDados>;

registerResponseContract('VendasServicos_ListaResponse', {
  itens: {
    type: 'array',
    required: true,
    items: {
      item_id:         { type: 'number',  required: true },
      os_id:           { type: 'number',  required: true },
      data:            { type: 'string',  required: true },
      franquia_id:     { type: 'number',  required: true },
      franquia_nome:   { type: 'string',  required: true },
      servico_id:      { type: 'number',  required: false },
      servico_nome:    { type: 'string',  required: true },
      prioridade_id:   { type: 'number',  required: false },
      prioridade_nome: { type: 'string',  required: true },
      quantidade:      { type: 'number',  required: true },
      via_combo:       { type: 'boolean', required: false },
    },
  },
  kpis: {
    type: 'array',
    required: true,
    items: {
      servico_id:      { type: 'number',  required: false },
      servico_nome:    { type: 'string',  required: true },
      prioridade_id:   { type: 'number',  required: false },
      prioridade_nome: { type: 'string',  required: true },
      quantidade:      { type: 'number',  required: true },
      itens:           { type: 'number',  required: true },
      itens_via_combo: { type: 'number',  required: false },
    },
  },
  combos: {
    type: 'array',
    required: true,
    items: {
      combo_id:   { type: 'number',  required: false },
      combo_nome: { type: 'string',  required: true },
      itens:      { type: 'number',  required: true },
      valor:      { type: 'number',  required: true },
    },
  },
})
